import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, Phone } from 'lucide-react';
import { Container } from '../Container';
import { motion } from 'framer-motion';
export function Hero() {
  const proofPoints = ['We Beat All Quotes', 'Factory Direct', 'Full Custom Designs', 'Team Packages', 'On-Time Delivery'];
  return <section className="relative bg-[#111827] text-white overflow-hidden" data-id="element-153">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-154">
        <img src="https://images.unsplash.com/photo-1515523110800-9415d13b84a8?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" alt="Custom Team Uniforms" className="w-full h-full object-cover opacity-40" data-id="element-155" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#111827] via-[#111827]/90 to-transparent" data-id="element-156"></div>
      </div>

      {/* Angular Red Accent */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-pts-red opacity-20 transform skew-x-12 translate-x-20 z-0 hidden lg:block" data-id="element-157"></div>

      <Container className="relative z-10 py-20 lg:py-32" data-id="element-158">
        <div className="max-w-3xl" data-id="element-159">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="font-oswald text-5xl sm:text-6xl lg:text-7xl font-bold leading-tight mb-6 uppercase" data-id="element-160">
            Custom Team Uniforms <br data-id="element-161" />
            <span className="text-pts-red" data-id="element-162">Without the Ordering Stress</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-lg sm:text-xl text-gray-300 mb-8 max-w-2xl leading-relaxed" data-id="element-163">
            Factory-direct custom uniforms, team packages, art support, samples,
            and quote-beating pricing for teams, leagues, schools, and
            organizations.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex flex-wrap gap-3 mb-10" data-id="element-164">
            {proofPoints.map((point, index) => <div key={index} className="flex items-center bg-white/10 backdrop-blur-sm px-3 py-1.5 rounded text-sm font-medium border border-white/20" data-id="element-165">
                <CheckCircle2 className="h-4 w-4 text-pts-red mr-2" data-id="element-166" />
                {point}
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex flex-col sm:flex-row gap-4 items-start sm:items-center" data-id="element-167">
            <Link to="/get-started" className="bg-pts-red hover:bg-pts-red-dark text-white px-8 py-4 rounded font-bold uppercase tracking-wide text-lg transition-colors w-full sm:w-auto text-center" data-id="element-168">
              Start My Team Order
            </Link>
            <Link to="/contact" className="bg-transparent border-2 border-white hover:bg-white hover:text-gray-900 text-white px-8 py-4 rounded font-bold uppercase tracking-wide text-lg transition-colors w-full sm:w-auto text-center" data-id="element-169">
              Send Us Your Quote
            </Link>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} className="mt-8 flex items-center text-gray-400" data-id="element-170">
            <Phone className="h-5 w-5 mr-2" data-id="element-171" />
            <span data-id="element-172">
              Prefer to call?{' '}
              <a href="tel:8882188647" className="text-white font-bold hover:text-pts-red transition-colors" data-id="element-173">
                888.218.8647
              </a>
            </span>
          </motion.div>
        </div>
      </Container>
    </section>;
}